import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import jsDig from "utils/jsDig";
import ScriptBoxes from "components/client_config/ppc_config/ScriptBoxes";
import { RouterContext } from "./Onboarding";

export default function Scripts(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();
  let exclaimTriangle = require("images/icons/exclaim-triangle.png");
  exclaimTriangle = <img className="scripts-exclaim-triangle" width="25" height="23" src={`/datapulse${exclaimTriangle}`} />;
  let exclaimTriangleMobile = require("images/icons/exclaim-triangle.png");
  exclaimTriangleMobile = <img className="scripts-exclaim-triangle-mobile" width="25" height="23" src={`/datapulse${exclaimTriangleMobile}`} />;
  const [validated, setValidation] = useState(false);

  const removeScripts = () => {
    let newScripts = props.scripts;

    let resetScripts = {};
    Object.entries(newScripts).forEach(([key, value]) => {
      if (typeof resetScripts[key] === "object") {
        resetScripts[key]["enabled"] = "0";
      } else {
        resetScripts[key] = "0"
      }
    });

    setIsChecked(resetScripts);
    props.setScripts(resetScripts);
  };

  const [isChecked, setIsChecked] = useState(props.scripts);
  const checkValidation = () => {
    const amount1 = Object.values(props.scripts).filter((el) => el === "1").length;
    const amount2 = jsDig(["scripts","exclude_nb_in_shopping","enabled"], props) == "1" ? 1 : 0;
    const amount = amount1 + amount2;

    if (amount > 0) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };

  const scripts = [
    {
      name: "text_converting_query_mining_script",
      title: "Text converting query mining script",
      desc: "Monthly iterates through all text campaign converted queries on an account for the previous two months and creates ad groups based on the converted query text.",
    },
    {
      name: "em_bm_negative_overlap_script",
      title: "EM/BM negative overlap script",
      desc: "Syncs negative keyword lists throughout the account to prevent overlap.",
    },
    {
      name: "negative_dsa_sync_script",
      title: "Negative DSA sync script",
      desc: "Syncs enabled account keywords as negatives in the '[DSA]' ad group to prevent bidding on pre_targeted queries.",
    },
    {
      name: "exclude_nb_in_shopping",
      title: "Exclude Non-Brand in Shopping",
      desc: "When you split Shopping campaigns on branded and non-branded search terms, you often still get non-branded search terms in your branded Shopping campaign(s). This script automatically excludes these terms.",
    },
    {
      name: "keyword_cannibalization_script",
      title: "Keyword Cannibalization Script",
      desc: "For every ad group in the entire account, adds all keywords NOT in that ad group to be an exact match negative version to that ad group.",
    },
    {
      name: "youtube_channel_excluder",
      title: "Exclude Foreign Language YouTube Channels",
      desc: "For display and video campaigns, Google is not quite so particular about targeting individual languages and video ads are often played in foreign language channels. This script identifies YouTube channels in undesired countries on which the video campaign(s) was/are played and automatically excludes them from the respective campaign.",
    },
  ];

  const [showBoxes, setShowBoxes] = useState(false);

  return (
    <>
      <Row className=" mb-1  justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">Scripts </p>
          </div>
          <div>
            <p className="f16 nunito-regular  primary ">Would you like to activate any PPC scripts at this time?</p>
          </div>
        </Col>
      </Row>

      <Row className=" mb-3 pb-3 justify-content-center">
        <Col md={6}>
          <div className="pb-2">
            <CustomTooltip
              faClass="far fa-question-circle pb-1 f16 text-info pt-1 pr-2"
              message={"Please see the detail descriptions of each script"}
              inline={true}
            />{" "}
            <span className=" f16 text-info pt-1 ">What does this mean?</span>
          </div>
          <div className="d-flex flex-column ">
            <Form.Check
              className="f16"
              name="ob-tracking"
              custom
              label="Yes I would."
              type="radio"
              id="ob-tracking-yes"
              onClick={() => {
                setShowBoxes(true);
                setValidation(false);
                checkValidation();
              }}
            />
            <Form.Check
              name="ob-tracking"
              className="f16"
              custom
              label="No I would not."
              type="radio"
              id="ob-tracking-no"
              onClick={() => {
                setShowBoxes(false);
                setValidation(true);
                removeScripts();
              }}
            />
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={6}>
          <div className="py-4 d-flex flex-md-row flex-column">
            <div className="d-none d-md-block" style={{ position: "relative", width: "65px", marginRight: "15px" }}>
              {exclaimTriangle}
            </div>
            <div className="text-center d-block d-md-none mb-3">
              {exclaimTriangleMobile}
            </div>
            <p className="f14 nunito-regular primary mb-0" style={{ verticalAlign: "middle" }}>
              Enabling/disabling these scripts without a thorough understanding of the function may have unintended consequences. Please proceed with caution.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col className="p-0" md={9}>
          <Row className="mt-4 justify-content-start">
            <Col>
              <Row style={{ backgroundColor: "#EEEEEE" }} className={`py-0 px-3 ${showBoxes ? "script-row" : "d-none"}`}>
                <ScriptBoxes scripts={scripts} setScripts={props.setScripts} isChecked={isChecked} setIsChecked={setIsChecked} checkValidation={checkValidation} client_account={props.client_account} onboarding />
              </Row>
              <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
